if (!customElements.get('primo-shop-navigation')) {
  customElements.define('primo-shop-navigation', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const details = this.querySelector('details');
      const mobile = window.matchMedia('(max-width: 989px)');
      const grid = this.querySelector('.primo-nav__category-grid');
      grid.style.setProperty('--primo-explore-rows', Math.ceil(grid.children.length / 2));
      grid.style.setProperty('--primo-explore-landscape-rows', Math.ceil(grid.children.length / 3));
      this.unlockExplore = () => {
        if (this.exploreScrollY === undefined) return;
        const scrollY = this.exploreScrollY;
        this.exploreScrollY = undefined;
        document.body.classList.remove('primo-explore-open');
        document.body.style.removeProperty('--primo-explore-scroll-top');
        window.scrollTo({ top: scrollY, behavior: 'instant' });
      };
      const syncScrollLock = () => {
        if (!details.open || !mobile.matches) { this.unlockExplore(); return; }
        if (this.exploreScrollY !== undefined) return;
        this.exploreScrollY = window.scrollY;
        document.body.style.setProperty('--primo-explore-scroll-top', `${-this.exploreScrollY}px`);
        document.body.classList.add('primo-explore-open');
      };
      details.addEventListener('toggle', syncScrollLock, { signal: this.events.signal });
      mobile.addEventListener('change', syncScrollLock, { signal: this.events.signal });
      syncScrollLock();
      const close = (focus = false) => {
        details.open = false;
        // Release synchronously: the toggle event runs after link navigation can begin.
        this.unlockExplore();
        if (focus) details.querySelector('summary').focus({ preventScroll: true });
      };
      this.addEventListener('click', event => {
        const link = event.target.closest('a[href]');
        if (!details.open || !link || !details.contains(link) || event.defaultPrevented ||
            event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
            link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        close();
      }, { signal: this.events.signal });
      // Do not cache a fixed body/open panel when navigating away or returning with Back.
      window.addEventListener('pagehide', () => close(), { signal: this.events.signal });
      window.addEventListener('pageshow', syncScrollLock, { signal: this.events.signal });
      this.addEventListener('keydown', event => { if (event.key === 'Escape' && details.open) { event.preventDefault(); close(true); } }, { signal: this.events.signal });
      this.querySelector('[data-close]').addEventListener('click', () => close(true), { signal: this.events.signal });
      document.addEventListener('click', event => { if (!details.contains(event.target)) close(); }, { signal: this.events.signal });
    }
    disconnectedCallback() { this.events?.abort(); this.unlockExplore?.(); }
  });
}
